import i18n from '../../../locales/i18n';
const toolsPurchase = {
  photoEnhancer: {
    title: i18n.t('toolsPurchasePhotoEnhancer:HitPawAIPhotoEnhancer'),
    text: [
      {
        content: i18n.t('toolsPurchasePhotoEnhancer:UnlimitedNumberOfSheets'),
      },
      { content: i18n.t('toolsPurchasePhotoEnhancer:SupportAllModels') },
      {
        content: i18n.t('toolsPurchasePhotoEnhancer:MagnificationAllX'),
      },
      {
        content: i18n.t('toolsPurchasePhotoEnhancer:OutputImageFormatMore'),
      },
      { content: i18n.t('toolsPurchasePhotoEnhancer:NoWatermark') },
      {
        content: i18n.t('toolsPurchasePhotoEnhancer:CancelAtAnytime'),
      },
      {
        content: i18n.t(
          'toolsPurchasePhotoEnhancer:HighPriorityProcessingSpeed'
        ),
      },
    ],
    price: [
      {
        price: i18n.t('toolsPurchasePhotoEnhancer:weekDayPrice'),
        totalPrice: i18n.t('toolsPurchasePhotoEnhancer:WeekTotalPrice'),
        subTitle: i18n.t('toolsPurchasePhotoEnhancer:Weekly'),
      },
      {
        price: i18n.t('toolsPurchasePhotoEnhancer:MonthDayPrice'),
        totalPrice: i18n.t('toolsPurchasePhotoEnhancer:MonthTotalPrice'),
        subTitle: i18n.t('toolsPurchasePhotoEnhancer:Monthly'),
      },
      {
        price: i18n.t('toolsPurchasePhotoEnhancer:YearDayPrice'),
        totalPrice: i18n.t('toolsPurchasePhotoEnhancer:YearTotalPrice'),
        subTitle: i18n.t('toolsPurchasePhotoEnhancer:Yearly'),
      },
    ],
    unit: i18n.t('toolsPurchasePhotoEnhancer:Day'),
    path: 'enhancer-check-out',
    func: 38,
  },
  videoEnhancer: {
    title: i18n.t('toolsPurchaseVideoEnhancer:HitPawOnlineAIVideoEnhance'),
    text: [
      {
        content: i18n.t('toolsPurchaseVideoEnhancer:ProcessingLimit'),
      },
      {
        content: i18n.t('toolsPurchaseVideoEnhancer:AllModelsAreAvailable'),
      },
      {
        content: i18n.t(
          'toolsPurchaseVideoEnhancer:SupportAllSubdivisionRateExport'
        ),
      },
      {
        content: i18n.t('toolsPurchaseVideoEnhancer:SupportPreviewVideo'),
      },
      {
        content: i18n.t('toolsPurchaseVideoEnhancer:BatchProcessingComingSoon'),
      },
      {
        content: i18n.t('toolsPurchaseVideoEnhancer:CancelAnyTime'),
      },
      {
        content: i18n.t(
          'toolsPurchaseVideoEnhancer:highPriorityProcessingSpeed'
        ),
      },
    ],
    price: [
      {
        price: i18n.t('toolsPurchaseVideoEnhancer:WeekDayPrice'),
        totalPrice: i18n.t('toolsPurchaseVideoEnhancer:WeekTotalPrice'),
        subTitle: i18n.t('toolsPurchaseVideoEnhancer:Weekly'),
      },
      {
        price: i18n.t('toolsPurchaseVideoEnhancer:MonthDayPrice'),
        totalPrice: i18n.t('toolsPurchaseVideoEnhancer:MonthTotalPrice'),
        subTitle: i18n.t('toolsPurchaseVideoEnhancer:Monthly'),
      },
      {
        price: i18n.t('toolsPurchaseVideoEnhancer:YearDayPrice'),
        totalPrice: i18n.t('toolsPurchaseVideoEnhancer:YearTotalPrice'),
        subTitle: i18n.t('toolsPurchaseVideoEnhancer:Yearly'),
      },
    ],
    unit: i18n.t('toolsPurchaseVideoEnhancer:Day'),
    path: 'video-enhancer-checkout',
    func: 39,
  },
  videoRemoveWaterMark: {
    title: i18n.t('toolsPurchaseRemoveWaterMark:watermarkRemoveTitle'),
    text: [
      { content: i18n.t('toolsPurchaseRemoveWaterMark:MaximumUpload500MB') },
      {
        content: i18n.t(
          'toolsPurchaseRemoveWaterMark:ExportVideoWithoutWaterMark'
        ),
      },
      { content: i18n.t('toolsPurchaseRemoveWaterMark:ExportWithoutLimits') },
    ],
    price: [
      {
        price: i18n.t('toolsPurchaseRemoveWaterMark:WeekTotalPrice'),
        subTitle: i18n.t('toolsPurchaseRemoveWaterMark:Weekly'),
      },
      {
        price: i18n.t('toolsPurchaseRemoveWaterMark:MonthWeekPrice'),
        totalPrice: i18n.t('toolsPurchaseRemoveWaterMark:MonthTotalPrice'),
        subTitle: i18n.t('toolsPurchaseRemoveWaterMark:Monthly'),
      },
      {
        price: i18n.t('toolsPurchaseRemoveWaterMark:YearWeekPrice'),
        totalPrice: i18n.t('toolsPurchaseRemoveWaterMark:YearTotalPrice'),
        subTitle: i18n.t('toolsPurchaseRemoveWaterMark:Yearly'),
      },
    ],
    unit: i18n.t('toolsPurchaseRemoveWaterMark:week'),
    path: 'product-check-out',
    fromProduct: 'video-watermark-remove',
    func: 1,
  },
  backgroundRemover: {
    title: i18n.t('toolsPurchaseBackgroundRemover:backgroundRemoverTitle'),
    text: [
      { content: i18n.t('toolsPurchaseBackgroundRemover:NoWatermark') },
      { content: i18n.t('toolsPurchaseBackgroundRemover:UnlimitedHDExport') },
      { content: i18n.t('toolsPurchaseBackgroundRemover:NoFileSizeLimit') },
      { content: i18n.t('toolsPurchaseBackgroundRemover:BatchProcessing') },
      { content: i18n.t('toolsPurchaseBackgroundRemover:UseAllTemplates') },
      { content: i18n.t('toolsPurchaseBackgroundRemover:CancelAtAnytime') },
      {
        content: i18n.t('toolsPurchaseBackgroundRemover:HighPriorityUnlimited'),
      },
    ],
    price: [
      {
        price: i18n.t('toolsPurchaseBackgroundRemover:WeekDayPrice'),
        totalPrice: i18n.t('toolsPurchaseBackgroundRemover:WeekTotalPrice'),
        subTitle: i18n.t('toolsPurchaseBackgroundRemover:Weekly'),
      },
      {
        price: i18n.t('toolsPurchaseBackgroundRemover:MonthDayPrice'),
        totalPrice: i18n.t('toolsPurchaseBackgroundRemover:MonthTotalPrice'),
        subTitle: i18n.t('toolsPurchaseBackgroundRemover:Monthly'),
      },
      {
        price: i18n.t('toolsPurchaseBackgroundRemover:YearDayPrice'),
        totalPrice: i18n.t('toolsPurchaseBackgroundRemover:YearTotalPrice'),
        subTitle: i18n.t('toolsPurchaseBackgroundRemover:Yearly'),
      },
    ],
    unit: i18n.t('toolsPurchaseBackgroundRemover:Day'),
    path: 'product-check-out',
    fromProduct: 'background-remover',
    func: 4,
  },
  removeTTWaterMark: {
    title: i18n.t('toolsPurchaseRemoveTTWaterMark:HitPawTikTokTitle'),
    text: [
      {
        content: i18n.t(
          'toolsPurchaseRemoveTTWaterMark:ProcessTiktokLinkWithoutLimits'
        ),
      },
      {
        content: i18n.t('toolsPurchaseRemoveTTWaterMark:FasterProcessingSpeed'),
      },
      { content: i18n.t('toolsPurchaseRemoveTTWaterMark:PrioritySupport') },
    ],
    price: [
      {
        price: i18n.t('toolsPurchaseRemoveTTWaterMark:WeekTotalPrice'),
        subTitle: i18n.t('toolsPurchaseRemoveTTWaterMark:Weekly'),
      },
      {
        price: i18n.t('toolsPurchaseRemoveTTWaterMark:MonthWeekPrice'),
        totalPrice: i18n.t('toolsPurchaseRemoveTTWaterMark:MonthTotalPrice'),
        subTitle: i18n.t('toolsPurchaseRemoveTTWaterMark:Monthly'),
      },
      {
        price: i18n.t('toolsPurchaseRemoveTTWaterMark:YearWeekPrice'),
        totalPrice: i18n.t('toolsPurchaseRemoveTTWaterMark:YearTotalPrice'),
        subTitle: i18n.t('toolsPurchaseRemoveTTWaterMark:Yearly'),
      },
    ],
    unit: i18n.t('toolsPurchaseRemoveTTWaterMark:week'),
    path: 'product-check-out',
    fromProduct: 'tiktok-watermark-remove',
    func: 3,
  },
  dynamicPhoto: {
    title: i18n.t('toolsPurchaseDynamicPhoto:UltTitle'),
    text: [
      { content: i18n.t('toolsPurchaseDynamicPhoto:NoImageSizeLimits') },
      { content: i18n.t('toolsPurchaseDynamicPhoto:UnlimitedImageUploads') },
      { content: i18n.t('toolsPurchaseDynamicPhoto:DownloadWithoutWatermark') },
      { content: i18n.t('toolsPurchaseDynamicPhoto:DownloadGif') },
    ],
    price: [
      {
        price: i18n.t('toolsPurchaseDynamicPhoto:priceWeek'),
        subTitle: i18n.t('toolsPurchaseDynamicPhoto:Weekly'),
      },
      {
        price: i18n.t('toolsPurchaseDynamicPhoto:priceMonth'),
        totalPrice: i18n.t('toolsPurchaseDynamicPhoto:monthTotalPrice'),
        subTitle: i18n.t('toolsPurchaseDynamicPhoto:Monthly'),
      },
      {
        price: i18n.t('toolsPurchaseDynamicPhoto:priceYear'),
        totalPrice: i18n.t('toolsPurchaseDynamicPhoto:yearTotalPrice'),
        subTitle: i18n.t('toolsPurchaseDynamicPhoto:Yearly'),
      },
    ],
    unit: i18n.t('toolsPurchaseDynamicPhoto:week'),
    path: 'product-check-out',
    fromProduct: 'dynamic-photo',
    func: 18,
  },
};

export default toolsPurchase;
